/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * A route's errorElement: the page failed to load, the dashboard around it
 * stays, and the member can try again or go back (LT-2013).
 */
import React, { useEffect } from "react";
import { Link, useNavigate, useRouteError } from "react-router-dom";
import { Button } from "@lemonadetraining/web-ui";
import { useTrainingHome } from "../hooks/useTrainingHome";

export default function RouteErrorCard({ what }: { what: string }) {
  const error = useRouteError();
  const navigate = useNavigate();
  const home = useTrainingHome();
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error(`[route] ${what} failed to load`, error);
  }, [what, error]);

  return (
    <div
      className="mx-auto flex max-w-md flex-col items-start gap-3 rounded-xl border p-6"
      role="alert"
      data-testid="route-error"
    >
      <p className="font-medium">We couldn&apos;t open this {what}</p>
      <p className="text-sm text-muted-foreground">
        Check your connection and try again. If it keeps happening, contact us.
      </p>
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => navigate(0)}>Try again</Button>
        <Button variant="outline" asChild>
          <Link to={home}>Back to My training</Link>
        </Button>
      </div>
    </div>
  );
}
